import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { Kanban } from 'lucide-react';

import { EmptyState } from '../../components/EmptyState';
import { Skeleton } from '../../components/Skeleton';
import { useProjectBoards } from '../../hooks/useBoards';

/**
 * Старый адрес доски `/projects/:key/board` (docs/06 §2).
 *
 * Доски стали множественными, поэтому адрес теперь включает id. Сюда попадают
 * ссылки из писем, закладок и уведомлений — их нельзя ломать, поэтому адрес
 * переадресуется на доску по умолчанию с сохранением строки запроса
 * (`?issue=…` открывает ту же панель задачи).
 */
export function LegacyBoardRedirect() {
  const { key } = useParams<{ key: string }>();
  const [searchParams] = useSearchParams();
  const { defaultBoard, isLoading } = useProjectBoards(key);

  if (isLoading) {
    return <Skeleton variant="card" count={4} />;
  }

  if (!defaultBoard) {
    return (
      <EmptyState
        icon={<Kanban size={20} />}
        title="У проекта нет досок"
        description="Создайте доску в настройках проекта, чтобы открывать задачи на канбане."
      />
    );
  }

  const query = searchParams.toString();
  const target = `/projects/${key ?? ''}/boards/${defaultBoard.id}${query.length > 0 ? `?${query}` : ''}`;
  return <Navigate to={target} replace />;
}